import React, { useMemo } from "react";
import { isNumber } from "lodash";

import { Order } from "../../../../../../../services";
import { useAppContext } from "../../../../../../../context";
import { CellContentRoot } from "..";

const IdleTimeCellContent: React.FC<IdleTimeCellContent.Props> = ({ item }) => {
	const { dateFns } = useAppContext();

	const content = useMemo<string>(() => {
		let idleTimeMilliseconds = 0;
		let withClients = 0;
		if (!item?.id) return "";
		if (isNumber(item?.additionalFields?.idleTimeMilliseconds)) {
			idleTimeMilliseconds = item.additionalFields.idleTimeMilliseconds;
		}
		if (isNumber(item?.downtimes?.withClients)) {
			withClients = item?.downtimes?.withClients;
		}
		const value = Math.max(withClients + idleTimeMilliseconds, 0);

		const date = dateFns.formatTime2(value, "HH:mm:ss", {
			timezone: "UTC",
		});

		return date;
	}, [
		dateFns,
		item?.additionalFields?.idleTimeMilliseconds,
		item?.downtimes?.withClients,
		item?.id,
	]);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace IdleTimeCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default IdleTimeCellContent;
